import { ThemeContext } from "@/providers/theme-context";
import { lazy, useContext, useMemo } from "react";
import { twMerge } from "tailwind-merge";
const DotLottieReact = lazy(() =>
  import("@lottiefiles/dotlottie-react").then((m) => ({
    default: m.DotLottieReact,
  })),
);

export function Loader({ className }: { className?: string }) {
  const { currentTheme } = useContext(ThemeContext);

  const themeId = useMemo(
    () => (currentTheme === "dark" ? "Default" : "Light"),
    [currentTheme],
  );

  return (
    <div className={twMerge("flex flex-col gap-y-1", className)}>
      <DotLottieReact
        className="animate-glow-theme size-20 shrink-0 grow"
        src={import.meta.env.VITE_LOTTIE_ANIMATION}
        speed={1.75}
        renderConfig={{ devicePixelRatio: 3 }}
        autoplay
        loop
        themeId={themeId}
      />
    </div>
  );
}
